import { navigate } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";

const VideoSection = ({ data }) => {
  return (
    <div className="block relative box-border w-full ">
      <div className="block relative w-full box-border">
        <div className="hidden md:block absolute top-0 left-0 w-full h-full overflow-hidden border-inherit z-0">
          {data.backgroundImage.mimeType.includes("image") ? (
            <GatsbyImage
              image={data.backgroundImage.gatsbyImageData}
              alt={data.backgroundImage.title}
              className="max-w-full w-full h-full object-cover align-bottom"
              objectFit="cover"
              objectPosition="center"
              loading="eager"
            />
          ) : (
            <div className="w-full h-full">
              <video
                title={data.backgroundImage.title}
                src={data.backgroundImage.file.url}
                autoPlay
                loop
                muted
                playsInline
                webkit-playsinline
                className="w-full h-full object-cover relative z-0"
              >
                <source
                  src={data.backgroundImage.file.url}
                  type={data.backgroundImage.mimeType}
                />
              </video>
            </div>
          )}
        </div>
        <div className="block md:hidden absolute top-0 left-0 w-full h-full overflow-hidden border-inherit z-0">
          {data.backgroundImageMobile.mimeType.includes("image") ? (
            <GatsbyImage
              className="max-w-full w-full h-[585px] md:h-full align-bottom"
              image={data.backgroundImageMobile.gatsbyImageData}
              alt={data.backgroundImageMobile.title}
              objectFit="cover"
              objectPosition="center"
              loading="eager"
            />
          ) : (
            <div className="w-full h-full">
              <video
                title={data.backgroundImageMobile.title}
                src={data.backgroundImageMobile.file.url}
                autoPlay
                loop
                muted
                playsInline
                webkit-playsinline
                className="w-full h-full object-cover relative z-0"
              >
                <source
                  src={data.backgroundImageMobile.file.url}
                  type={data.backgroundImageMobile.mimeType}
                />
              </video>
            </div>
          )}
        </div>
        <div
          className="relative flex flex-col items-center justify-center min-h-[200px] text-center box-border after:contents-['']
          after:absolute after:bg-black/40 after:z-[1] after:w-full after:h-full after:top-0 after:left-0 after:border-inherit
          py-[50px] lg:py-[200px] px-5 lg:px-[90px]"
        >
          <h2
            className="text-[40px] md:text-[62px] tracking-[0.4px] leading-[60px] md:leading-[93px] lg:text-center text-white
        font-bold z-[3]"
          >
            {data.title}
          </h2>
          {data.description && (
            <h5 className="text-[17px] tracking-[0.4px] leading-6 lg:text-center text-white mt-5 mb-[10px] z-[3] font-bold">
              {data.description.description}
            </h5>
          )}
          <button
            onClick={() => navigate(data.buttonLink)}
            className="px-[35px] py-3 cursor-pointer rounded-full no-underline text-[#1f1f1f] h-14 lg:mx-auto text-[15px]
            font-bold tracking-[1px] leading-7 box-border mt-5 z-[3] hover:scale-105 transform transition-all duration-200 bg-white
            flex items-center justify-center"
          >
            <span>{data.buttonText}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default VideoSection;
